<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>公司类型管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateDialog()">
          新增公司类型
        </v-btn>
      </v-col>
    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="companyTypes"
      :items-per-page="5"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditCategoryDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeleteCategoryConfirm(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-company-type-popup 
    ref="createPopup"
    @type-created="refresh"
    ></create-company-type-popup>
    
    <edit-company-type-popup
      ref="editPopup"
      :item="selectedCategory"
      @type-updated="refresh"
    ></edit-company-type-popup>

    <delete-company-type-confirmation
      ref="deleteConfirmation"
      :item="selectedCategory"
      @type-deleted="refresh"
    ></delete-company-type-confirmation>
  </v-container>
</template>

<script>
import { dropdownOptionsApi } from '@/api/dropdownOptions';

export default {
  components: {
    CreateCompanyTypePopup: () => import('@/components/companyType/CreateCompanyTypePopup.vue'),
    DeleteCompanyTypeConfirmation: () => import('@/components/companyType/DeleteCompanyTypeConfirmation.vue'),
    EditCompanyTypePopup: () => import('@/components/companyType/EditCompanyTypePopup.vue')
  },
  created() {
    this.fetchCompanyTypes();
  },
  data() {
    return {
      headers: [
        { text: "公司名称", value: "name" },
        { text: "国内类型", value: "domestic"},
        { text: "创建时间", value: "createdDateTime" },
        { text: "操作", value: "actions", sortable: false },
      ],
      companyTypes: [],
      selectedCategory: {"name": "", "createdDate": ""},
      selectedCategories: [],
      loading: false,
    }
  },
  methods: {
    showEditCategoryDialog(item) {
      this.selectedCategory = item;
      this.$refs.editPopup.open(item);
    },
    showDeleteCategoryConfirm(item) {
      this.selectedCategory = item;
      this.$refs.deleteConfirmation.open();
    },
    
    async refresh() {
      this.fetchCompanyTypes();
    },

    showCreateDialog() {
      this.$refs.createPopup.open();
    },

    async fetchCompanyTypes() {
      this.loading = true;
      try {
        const response = await dropdownOptionsApi.getCompanyTypes();
        this.companyTypes = response.data.map(companyType => ({
          ...companyType,
          id: companyType.id,
          name: companyType.name,
          domestic: companyType.domestic
        }));
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取分类列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin-right: 8px;
}
</style>